import thunk from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';

import dataReducer from './reducers/dataReducer';
import uiReducer from './reducers/uiReducer';

const initialState = {}

const middleware = [thunk];

const reducers = combineReducers({
    data: dataReducer,
    ui: uiReducer
});

const store = window.navigator.userAgent.includes('Chrome') ? 
        createStore(
            reducers,
            initialState,
            compose(
                applyMiddleware(...middleware),
                window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())) :
        createStore(
            reducers,
            initialState,
            compose(applyMiddleware(...middleware)))



export default store;
